import { Link, NoWrap } from '@components/Common.styles';
import {
  TableColumns,
  createTableColumnsV2,
} from '@components/TableV2/helpers/createTableColumnsV2';
import { Translate, useI18n } from '@hooks/useI18n';
import { TabEventKeys } from '@utils/constants';
import { getTypeTranslation } from './getTypeTranslation';
import { IMerchantReceivableWithPaymentRefAndExternalUuid } from './types';

interface IUseGetMerchantReceivablesColumns {
  translate: Translate;
}

export const useGetMerchantReceivablesColumns = ({
  translate,
}: IUseGetMerchantReceivablesColumns) => {
  const { getLocaleCurrencyValue, getLocaleDate } = useI18n();

  const columns: TableColumns<IMerchantReceivableWithPaymentRefAndExternalUuid> =
    [
      {
        field: 'receivable_date',
        label: translate('TITLE.DATE'),
        mapCustomValue: ({ row: { receivable_date: receivableDate } }) =>
          receivableDate && getLocaleDate({ date: receivableDate }),
      },
      {
        field: 'receivable_type',
        label: translate('TITLE.TYPE'),
        mapCustomValue: ({ row: { receivable_type: receivableType } }) =>
          getTypeTranslation(receivableType, translate),
      },
      {
        field: 'amount',
        label: translate('LABEL.AMOUNT'),
        mapCustomJSX: ({
          row: {
            amount: { amount, currency },
          },
        }) => (
          <NoWrap>{getLocaleCurrencyValue({ value: amount, currency })}</NoWrap>
        ),
      },
      {
        field: 'contract_uuid',
        label: translate('OPS_PORTAL.LABEL.PAYMENT_PLAN_REFERENCE'),
        mapCustomJSX: ({ row }) => (
          <Link
            state={{ activeKey: TabEventKeys.CONTRACT_OVERVIEW }}
            to={`/all_contracts/${row.external_uuid}`}
          >
            {row?.payment_plan_ref}
          </Link>
        ),
      },
      {
        field: 'status',
        label: translate('TITLE.STATUS'),
        mapCustomValue: ({ row: { status } }) =>
          translate(`OPS_PORTAL.LABEL.${status.toUpperCase()}`),
      },
      {
        field: 'payment_date',
        label: translate('OPS_PORTAL.TITLE.PAYMENT_DATE'),
        mapCustomValue: ({ row: { payment_date: paymentDate } }) =>
          paymentDate && getLocaleDate({ date: paymentDate }),
      },
      {
        field: 'bank_reference',
        label: translate('OPS_PORTAL.LABEL.BANK_TRANSACTION_REFERENCE'),
      },
    ];

  return createTableColumnsV2({ columns });
};
